// test2
(2 && 0);
